/**
 * TypeScript Interfaces for Custom Post Generation Prompts Feature
 * Feature: 015-custom-prompts
 * Date: 2026-01-04
 */

/**
 * Known Handlebars Variables
 * Variables that can be used in prompt templates and will be substituted from business profile
 */
export type KnownVariable =
  | 'brand_name'
  | 'company_name'
  | 'business_category'
  | 'business_description'
  | 'website_url';

/**
 * Prompt Validation Result
 * Result of frontend prompt validation
 */
export interface IPromptValidationResult {
  isValid: boolean; // Overall validation status
  errors: string[]; // Blocking errors (prevent save)
  warnings: string[]; // Non-blocking warnings (allow save)
  length: number; // Character count after trim
}

/**
 * Known Variables Documentation
 * Static list of all available variables with metadata
 */
export const KNOWN_VARIABLES: readonly {
  name: KnownVariable;
  displayName: string;
  description: string;
  example: string;
  required: boolean;
}[] = [
  {
    name: 'brand_name',
    displayName: 'Brand Name',
    description: 'Your brand or business name',
    example: 'CleanSpark Pro',
    required: false,
  },
  {
    name: 'company_name',
    displayName: 'Company Name',
    description: 'Legal company name',
    example: 'CleanSpark Professional Services LLC',
    required: false,
  },
  {
    name: 'business_category',
    displayName: 'Business Category',
    description: 'Type of business or industry',
    example: 'Commercial Cleaning',
    required: false,
  },
  {
    name: 'business_description',
    displayName: 'Business Description',
    description: 'Description of your business services',
    example: 'We provide professional cleaning services...',
    required: false,
  },
  {
    name: 'website_url',
    displayName: 'Website URL',
    description: 'Your business website',
    example: 'https://cleansparkpro.com',
    required: false,
  },
] as const;

/**
 * Validation Constants
 * Min/max lengths for prompt validation
 */
export const PROMPT_VALIDATION = {
  MIN_LENGTH: 50,
  MAX_LENGTH: 10000,
  DEBOUNCE_MS: 200,
} as const;
